import * as React from 'react';

import {
  motion,
} from 'framer-motion';

import {
  Colors,
} from '@bluecurrent/web-component-lib';

export default function Bar({
  index,
  height,
  type,
  isTranslucent,
  isRounded,
  isNegative,
  isVisible,
}) {
  if (!isVisible) return null;

  const color = type === 'gas' ? Colors.BLUE : Colors.ORANGE;

  return (
    <motion.div
      initial={{
        minHeight: 0,
        backgroundColor: `${Colors.MEDIUM_WHITE}80`,
      }}
      animate={{
        minHeight: `calc(${height}% - 4px)`,
        backgroundColor: isNegative
          ? isTranslucent ? `${Colors.GREEN}80` : Colors.GREEN
          : isTranslucent ? `${color}80` : color,
      }}
      exit={{
        minHeight: 0,
        backgroundColor: `${Colors.MEDIUM_WHITE}80`,
      }}
      transition={{
        duration: 0.2,
        ease: 'easeInOut',
        delay: index / 100,
        stiffness: 100,
      }}
      style={{
        width: '80%',
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        borderBottomLeftRadius: isRounded ? 5 : 0,
        borderBottomRightRadius: isRounded ? 5 : 0,
        position: 'relative',
        zIndex: 1,
        boxShadow: 'rgba(136, 136, 141, 0.15) 0px 2px 8px',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          height: '100%',
          width: '100%',
          backgroundColor: 'transparent',
          position: 'absolute',
          borderTopLeftRadius: 5,
          borderTopRightRadius: 5,
          borderBottomLeftRadius: isRounded ? 5 : 0,
          borderBottomRightRadius: isRounded ? 5 : 0,
          border: `solid 2px ${isNegative ? `${Colors.GREEN}99` : `${color}99`}`,
          transition: `border .18s ease-in-out ${index / 100}s`,
        }}
      />
    </motion.div>
  );
}
